import React from 'react'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { IQuizzesResponse } from 'src/api/quizzes/types'
import { iRootState } from 'src/store'
import { getQuizzes } from 'src/api/quizzes/quizzes'
import { LANDING } from 'src/constants/routes'

const stateSelector = (state: iRootState) => ({
  userId: state.user.data?.id,
  isAuthResolved: state.user.isAuthResolved,
})

export const useQuizzesData = (quizStatus: 'new' | 'completed') => {
  const { push } = useHistory()

  const [isLoading, setIsLoading] = React.useState(true)
  const [quizzesData, setQuizzesData] = React.useState<IQuizzesResponse | null>(
    null
  )

  const { userId, isAuthResolved } = useSelector(stateSelector)

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const responseData = await getQuizzes(quizStatus)
        setQuizzesData(responseData)
      } catch (e) {
        console.error(e)
        if (e.code === 401) push(LANDING)
      }
      setIsLoading(false)
    }
    // @TODO: get rid of this in all used places
    if (isAuthResolved && userId) {
      fetchData()
    }

    if (isAuthResolved && !userId) {
      push(LANDING)
    }
  }, [isAuthResolved, push, quizStatus, userId])

  return {
    isLoading,
    quizzesData,
  }
}
